import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NotificationItem } from '@ps/notification-models';

import { NotificationApi } from '../api/notification.api';
import { NotificationUnreadCounts } from '../state/notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly _notificationApi = inject(NotificationApi);

  public notifications(limit: number): Observable<NotificationItem[]> {
    return this._notificationApi.notifications(limit);
  }

  public unreadCounts(): Observable<NotificationUnreadCounts> {
    return this._notificationApi.unreadCounts();
  }

  public viewAll(): Observable<number> {
    return this._notificationApi.viewAll();
  }

  public markViewed(
    notificationId: string,
    viewed: boolean,
  ): Observable<NotificationItem> {
    return this._notificationApi.markViewed(notificationId, viewed);
  }
}
